import mapLocale, { getLang } from '../I18N';
import React from 'react';
import ReactDOM from 'react-dom';
import { message } from 'tntd';
import ReferenceCheck from './ReferenceCheck';
import './index.less';

export default (props) => {
  const { rq } = props || {};

  const appendModal = (resolve, { type, result: referenceData = [] }) => {
    const modalWrap = document.createElement('div');
    modalWrap.setAttribute('id', 'tddc-reference-check-modal');

    const removeModal = () => {
      const tddcModal = document.querySelectorAll('#tddc-reference-check-modal');
      if (tddcModal) {
        tddcModal.forEach((ele) => ele?.parentNode?.removeChild(ele));
      }
      modalWrap && modalWrap?.parentNode?.removeChild(modalWrap);

      if (document.body.getAttribute('style')) {
        document.body.removeAttribute('style');
      }

    };

    removeModal();
    
    document.body.appendChild(modalWrap);

    // 能进行下一步操作
    const canNextOpera = !!type && !['STRONG'].includes(type);

    ReactDOM.render(
        <ReferenceCheck {...props} referenceData={referenceData} type={type}  modalWrap={modalWrap} canNextOpera={canNextOpera} resolve={resolve} removeModal={removeModal}/>,
        modalWrap,
    );
  };

  if (rq && typeof rq === 'function') {
    const I18N = mapLocale[getLang()];
    return new Promise((resolve, reject) => {
      return rq().then((res) => {
        const { success, data } = res || {};
        if (success) {
          const { type } = data || {};
          if (type === 'NO_EXIST') {
            resolve(type);
          } else if (type) {
            appendModal(resolve, data);
          }
        } else {
          reject(I18N.referencecheck.index.chaXunGuanLianGuan);
        }
      });
    });
  } else {
    message.error(I18N.referencecheck.index.qingTiGongYiGe); 
  }
};
